import React, { useState, ChangeEvent } from 'react';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const containerClass = 'relative flex w-full items-center';

const inputClass =
  'w-full rounded border border-slate-400 bg-input-background py-3 pl-4 pr-30px text-slate-50';

// Increased padding to make a larger clickable area.
const clearIconClass = 'absolute right-2.5 flex items-center p-2.5 cursor-pointer';

type Props = {
  placeholder?: string;
  onSearchTermChanged: (text: string) => void;
};

export const SearchBox = ({ placeholder, onSearchTermChanged }: Props): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    onSearchTermChanged(value);
  };

  const handleClearClick = () => {
    setSearchTerm('');
    onSearchTermChanged('');
  };

  return (
    <div className={containerClass}>
      <input
        className={inputClass}
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleInputChange}
      />
      {searchTerm && (
        <div className={clearIconClass} onClick={handleClearClick}>
          <FontAwesomeIcon icon={faTimes} color="#ffffff" />
        </div>
      )}
    </div>
  );
};
